"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const nav_frontend_js_utils_1 = require("nav-frontend-js-utils");
const tab_1 = __importDefault(require("./tab"));
const tabsCls = (props) => (0, classnames_1.default)("nav-frontend-tabs", props.className, {
    "nav-frontend-tabs--kompakt": props.kompakt,
});
class TabsPure extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleKeyDown = (e) => {
            let newIndex;
            const modifier = !this.props.arrowKeysAutoSwitchTabs
                ? this.focusIndex
                : this.aktivIndex;
            const keyCode = e.keyCode || e.which;
            switch (keyCode) {
                case nav_frontend_js_utils_1.keyCodes.right:
                    newIndex = modifier < this.getNumTabs() - 1 ? modifier + 1 : 0;
                    break;
                case nav_frontend_js_utils_1.keyCodes.left:
                    newIndex = modifier > 0 ? modifier - 1 : this.getNumTabs() - 1;
                    break;
                default:
                    break;
            }
            if (newIndex === undefined)
                return;
            if (!this.props.arrowKeysAutoSwitchTabs) {
                this.linkRefs[newIndex].focus();
            }
            else if (typeof this.props.onChange === "function")
                this.props.onChange(e, newIndex);
        };
        this.handleClick = (e, index, customClickHandler) => {
            e.preventDefault();
            if (typeof this.props.onChange === "function")
                this.props.onChange(e, index);
            if (typeof customClickHandler === "function")
                customClickHandler(e, index);
        };
        this.aktivIndex = 0;
        this.focusIndex = 0;
        this.linkRefs = [];
    }
    getNumTabs() {
        if (this.props.children)
            return React.Children.count(this.props.children);
        return this.props.tabs ? this.props.tabs.length : 0;
    }
    renderTabs() {
        if (this.props.children) {
            return React.Children.map(this.props.children, (child, i) => {
                if (React.isValidElement(child)) {
                    const { aktiv } = child.props;
                    if (aktiv)
                        this.aktivIndex = i;
                    return React.cloneElement(child, {
                        onClick: (e) => this.handleClick(e, i, child.props.onClick),
                        onKeyDown: (e) => this.handleKeyDown(e),
                        linkRef: (button) => (this.linkRefs[i] = button),
                        onFocus: () => (this.focusIndex = i),
                    });
                }
                return null;
            });
        }
        if (this.props.tabs) {
            return this.props.tabs.map((tab, i) => {
                if (tab.aktiv)
                    this.aktivIndex = i;
                return (React.createElement(tab_1.default, Object.assign({ key: (0, nav_frontend_js_utils_1.guid)(), onClick: (e) => this.handleClick(e, i, tab.onClick), onKeyDown: (e) => this.handleKeyDown(e), linkRef: (button) => (this.linkRefs[i] = button), onFocus: () => (this.focusIndex = i) }, tab)));
            });
        }
        return null;
    }
    render() {
        const domProps = (0, nav_frontend_js_utils_1.omit)(this.props, "children", "className", "tabs", "kompakt", "arrowKeysAutoSwitchTabs");
        return (React.createElement("div", Object.assign({ className: tabsCls(this.props) }, domProps),
            React.createElement("ul", { className: "nav-frontend-tabs__tab-list", role: "tablist" }, this.renderTabs())));
    }
}
TabsPure.Tab = tab_1.default;
TabsPure.defaultProps = {
    kompakt: false,
    arrowKeysAutoSwitchTabs: true,
};
exports.default = TabsPure;
